import { Auth, Storage } from "aws-amplify"
import { useState } from "react"
import { v4 as uuidv4 } from "uuid"

// Unique per upload, never the bare filename: the bucket has no versioning, so
// reusing a key destroys bytes that already-issued invoices reference by URL.
// The original name is kept as a prefix to keep keys recognisable.
function uniqueKey(filename) {
  const safe = filename.split(" ").join("_")
  const dot = safe.lastIndexOf(".")
  const id = uuidv4()

  return dot > 0
    ? `${safe.slice(0, dot)}-${id}${safe.slice(dot)}`
    : `${safe}-${id}`
}

export const useUtils = () => {
  const [uploading, setUploading] = useState(false)

  async function generateFileUrl(file, level) {
    try {
      setUploading(true)
      const storageLevel = level ? level : "protected"
      const key = uniqueKey(file.name)
      await Storage.put(key, file, {
        level: storageLevel,
        contentType: file.type,
      })
      const currentUserCredentials = await Auth.currentUserCredentials()
      const url = `${process.env.REACT_APP_PLANHOPPER_STORAGE_URL}/${storageLevel}/${currentUserCredentials.identityId}/${key}`
      setUploading(false)
      return url
    } catch (error) {
      console.log("Error uploading file: ", error)
    }
  }

  return {
    generateFileUrl,
    uploading,
  }
}
